/**
 * Site Name Configuration
 * This file is auto-generated based on the SITE_NAME environment variable
 * Used to replace {{SITE_NAME}} placeholders in locale files
 * 
 * Run: node scripts/update-site-name-config.js (or it runs automatically during build)
 */

// Site name from environment variable (set at build time)
export const SITE_NAME = 'Transdates'

export default SITE_NAME
